import { changeLocalizationById, getLocalizationsList } from '../../request'
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, hideErrorMessage, closeChangeLocaleModal } from './ui'

//Загрузка списка локализаций
export const LOCALIZATIONS_LOADING_START = "Localizations list loading start";
export const LOCALIZATIONS_LOADING_SUCCESS = "Localizations list loading success";
export const LOCALIZATIONS_LOADING_FAILED = "Failure during localizations list load";

//Изменение значения локализации
export const CHANGE_LOCALIZATION_START = "Change localization start";
export const CHANGE_LOCALIZATION_SUCCESS = "Change localization success";
export const CHANGE_LOCALIZATION_FAILED = "Change localization failed";

//Пагинация
export const CHANGE_LOCALIZATIONS_PAGE = "Change localizations page";
export const CHANGE_LOCALIZATIONS_LIMIT = "Change localizations limit";

//Поиск
export const CHANGE_LOCALIZATIONS_SEARCH = "Change localizations search";
export const START_LOCALIZATIONS_SEARCH = "Switch localizations search";
export const CLEAR_LOCALIZATIONS_SEARCH = "Clear localizations search";

const startLoading = () => ({
  type: LOCALIZATIONS_LOADING_START
});

const loadSuccess = localizations => ({
  type: LOCALIZATIONS_LOADING_SUCCESS,
  payload: {
    localizations: localizations || []
  }
});

const loadFailure = () => ({
  type: LOCALIZATIONS_LOADING_FAILED,
});

//Загрузка списка консультантов
export const getLocalizationsListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());

    await dispatch(checkAndRenewTokens());

    let localizations;

    try {
      const { lang, ...rest } = payload
      const accessToken = localStorage.getItem("accessToken");

      const res = await getLocalizationsList(accessToken, rest);

      const langOrder = ['RU', 'EN', 'MN'];

      const mappedPayloadItems = res.items.reduce((acc, item) => {
        if (lang?.length && !lang?.includes(item.lang)) {
          return acc
        };

        item.key in acc ? acc[item.key].push(item) : acc[item.key] = [item];

        return acc
      }, {});

      Object.values(mappedPayloadItems).forEach(items => {
        items.sort((a, b) => langOrder.indexOf(a.lang) - langOrder.indexOf(b.lang));
      });

      localizations = { ...res, items: mappedPayloadItems };
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка локализаций!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(localizations));
  };
};

const changeLocalizationStart = () => ({
  type: CHANGE_LOCALIZATION_START
});

const changeLocalizationSuccess = localization => ({
  type: CHANGE_LOCALIZATION_SUCCESS,
  payload: {
    localization
  }
});

const changeLocalizationFailure = () => ({
  type: CHANGE_LOCALIZATION_FAILED
});

//Изменение значения локализации
export const changeLocalizationAsync = (payload) => {
  return async (dispatch) => {
    dispatch(changeLocalizationStart());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let localization;
    try {
      const accessToken = localStorage.getItem("accessToken");

      localization = await changeLocalizationById(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при изменении локализации!"));
      return dispatch(changeLocalizationFailure());
    }
    dispatch(closeChangeLocaleModal())
    return dispatch(changeLocalizationSuccess({
        id: localization.id,
        key: localization.key,
        lang: localization.lang,
        value: localization.value,
    }));
  };
}

//Пагинация на странице списка консультантов
export const changeLocalizationsPage = activePage => ({
  type: CHANGE_LOCALIZATIONS_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка консультантов
export const changeLocalizationsLimit = activeLimit => ({
  type: CHANGE_LOCALIZATIONS_LIMIT,
  payload: { activeLimit }
});

//Поиск
export const changeLocalizationsSearch = value => ({
  type: CHANGE_LOCALIZATIONS_SEARCH,
  payload: { value }
});

export const startLocalizationsSearch = value => ({
  type: START_LOCALIZATIONS_SEARCH,
  payload: { value }
});

export const clearLocalizationsSearch = () => ({
  type: CLEAR_LOCALIZATIONS_SEARCH,
});
